import React, { createContext, useState, useContext } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('es');

  const t = (keyPath) => {
    const keys = keyPath.split('.');
    let value = translations[lang];
    for (const key of keys) {
      if (value[key] === undefined) return keyPath;
      value = value[key];
    }
    return value;
  };

  const toggleLang = () => setLang(prev => prev === 'es' ? 'en' : 'es');

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);